/**
 * Subdomain Detection Utility
 * Detects and handles custom subdomains for routing
 */

// Get the current subdomain
export const getSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Handle localhost and IP addresses (no subdomain)
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }
  
  // Split hostname into parts
  const parts = hostname.split('.');
  
  // For domains like artists.artistscanner.ai or admin.artistscanner.ai
  // parts = ['artists', 'artistscanner', 'ai'] or ['admin', 'artistscanner', 'ai']
  // We want to extract the first part if there are more than 2 parts (subdomain.domain.tld)
  
  // Handle preview domains like xxx.preview.emergentagent.com
  if (hostname.includes('preview.emergentagent.com')) {
    return null; // No subdomain logic for preview
  }
  
  // For artistscanner.ai (parts.length = 2), no subdomain
  // For artists.artistscanner.ai (parts.length = 3), subdomain = 'artists'
  // For www.artistscanner.ai (parts.length = 3), subdomain = 'www' (treat as no subdomain)
  
  if (parts.length >= 3) {
    const subdomain = parts[0].toLowerCase();
    // Ignore 'www' as a subdomain
    if (subdomain === 'www') {
      return null;
    }
    return subdomain;
  }
  
  return null;
};

// Check if current domain is the artists subdomain
export const isArtistsSubdomain = () => {
  return getSubdomain() === 'artists';
};

// Check if current domain is the admin subdomain
export const isAdminSubdomain = () => {
  return getSubdomain() === 'admin';
};

// Check if current domain is the main domain (no subdomain)
export const isMainDomain = () => {
  return getSubdomain() === null;
};

// Get the appropriate login redirect based on subdomain
export const getLoginRedirect = (user) => {
  const subdomain = getSubdomain();
  
  if (subdomain === 'artists') {
    // Artists subdomain - always go to artist dashboard or setup
    if (user?.role === 'artist') {
      if (user?.artist_profile_status === 'approved') {
        return '/artist-dashboard';
      }
      return '/artist-profile-setup';
    }
    return '/artist/signup';
  }
  
  if (subdomain === 'admin') {
    // Admin subdomain - go to admin dashboard
    if (user?.role === 'admin' || user?.role === 'management') {
      return '/admin';
    }
    return '/team/login'; // Stay on team login if not admin
  }
  
  // Main domain - go to appropriate dashboard
  if (user?.role === 'admin' || user?.role === 'management') {
    return '/admin';
  }
  if (user?.role === 'artist') {
    return '/artist-dashboard';
  }
  return '/dashboard';
};

export default {
  getSubdomain,
  isArtistsSubdomain,
  isAdminSubdomain,
  isMainDomain,
  getLoginRedirect
};
